import {
  SectionTitle,
  SectionTitleHeading,
  SectionTitleBody
} from "@silversea-ssc/ui-components-react";
import ExpeditionTeamSlider from "components/ExpeditionTeamSlider/ExpeditionTeamSlider";

import React, { ReactElement } from "react";
import { ExpeditionTeamMemberFragment } from "types/graphql-types";

type Props = {
  title: string | undefined;
  content: string | undefined | ReactElement;
  expeditionTeam: ExpeditionTeamMemberFragment[];
  id: string;
};

const ExpeditionTeamMembers: React.FC<Props> = ({
  title,
  content,
  expeditionTeam,
  id
}) => {
  return (
    <ExpeditionTeamSlider id={id} expeditionTeam={expeditionTeam}>
      <SectionTitle variant="wide">
        <SectionTitleHeading>{title}</SectionTitleHeading>
        <SectionTitleBody>{content}</SectionTitleBody>
      </SectionTitle>
    </ExpeditionTeamSlider>
  );
};

export default ExpeditionTeamMembers;
